import styles from './BaseSignPage.module.scss';
import { Header } from 'src/v2/pages/auth/components/Header';
import { Appearance } from 'src/types/models/Appearance';
import { SignupFeaturesSection } from 'src/v2/pages/auth/components/SignupFeaturesSection/SignupFeaturesSection';
import { SocialProof } from 'src/v2/pages/auth/components/SocialProofSection';
import { useBreakpoint } from 'src/hooks';

interface BaseSignPageProps {
  seoTitle?: string;
  seoDescription?: string;
  children?: React.ReactNode;
}
export const BaseSignPage = ({
  seoTitle,
  seoDescription,
  children,
}: BaseSignPageProps) => {
  const { isTabletAndUp } = useBreakpoint();
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <Header
            seoTitle={seoTitle}
            seoDescription={seoDescription}
            appearance={Appearance.LIGHT}
            showLink={false}
          />
          {children}
          {isTabletAndUp || <SocialProof />}
        </div>
        <div className={styles.rightContainer}>
          <SignupFeaturesSection />
          <div className={styles.socialProofWrapper}>
            <SocialProof />
          </div>
        </div>
      </div>
    </div>
  );
};
